import React from 'react';
import { useTournament } from '../TournamentContext';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlusSquare, faUsers, faGamepad, faTrophy, faMedal, faPenToSquare, faScrewdriverWrench
} from '@fortawesome/free-solid-svg-icons';
import './Admin.css'; 

const Admin = () => {
  const { tournament } = useTournament();

  const steps = [
    {
      title: 'Update Tournament Info',
      items: [
        { label: 'Update Tournament', icon: faPenToSquare, path: 'update-tournament' }
      ]
    },
    {
      title: 'Step 1: Manage Divisions',
      items: [
        { label: 'Add Division', icon: faPlusSquare, path: 'add-division' },
        { label: 'Update/Delete Division', icon: faPlusSquare, path: 'manage-division' }
      ]
    },
    {
      title: 'Step 2: Manage Teams',
      items: [
        { label: 'Add Team', icon: faUsers, path: 'add-team' },
        { label: 'Update/Delete Team', icon: faUsers, path: 'manage-team' }
      ]
    },
    {
      title: 'Step 3: Manage Games',
      items: [
        { label: 'Add Game', icon: faGamepad, path: 'add-game' },
        { label: 'Update/Delete Game', icon: faGamepad, path: 'manage-game' },
        { label: 'Bulk Upload Games', icon: faGamepad, path: 'upload-game' }
      ]
    },
    {
      title: 'Step 4: Manage Scores',
      items: [
        { label: 'Add/Update Score', icon: faTrophy, path: 'add-score' }
      ]
    },
    {
      title: 'Step 5: Manage Standings',
      items: [
        { label: 'View Standing Details', icon: faTrophy, path: 'admin-standing' },
        { label: 'Update Team Standings', icon: faTrophy, path: 'update-teamstats' }
      ]
    },
    {
      title: 'Step 6: Add Wildcard/Playoff Games (optional)',
      items: [
        // { label: 'Add New Playoff Game', icon: faMedal, path: 'add-playoffGame' },
        // { label: 'Manage Standard Playoff Game', icon: faMedal, path: 'Manage-standardplayoff' },
        { label: 'Add WildCard/Playoff Game', icon: faMedal, path: 'add-playoffgame' }
      ]
    },
    {
      title: 'Step 7: Manage Playoffs',
      items: [
        // { label: 'Add New Playoff Game', icon: faMedal, path: 'add-playoffGame' },
        { label: 'Manage Playoff Bracket', icon: faMedal, path: 'manage-playoff' },
        //  { label: 'Creat Playoff Games with Standing', icon: faMedal, path: 'manage-standardplayoff' }
      ]
    }
  ];

  return (
    <div className="admin-page">
      <h1>  <FontAwesomeIcon icon={faScrewdriverWrench} size="1x"/> &nbsp; Admin Page</h1>
      <p>Create new divisons, teams, games, update standing and much more!</p>

      <div className="admin-steps">
        {steps.map((step, i) => (
          <div key={i} className="step-section">
            <h3 className="step-title">{step.title}</h3>
            <div className="admin-action-cards">
              {step.items.map(({ label, icon, path }) => (
                <Link
                  key={path}
                  to={`/admin/${tournament?.linkindex}/${path}`}
                  className="admin-action-card"
                >
                  <FontAwesomeIcon icon={icon} size="2x" />
                  <br />
                  <span>{label}</span>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Admin;
